// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__K-edi","content":"styles_content__25v8P","checkbox":"styles_checkbox__2F5_M","checkboxLabel":"styles_checkboxLabel__11nFL"};